<template>
    <div class="row" style="margin-top:20px;">
        <div class="col-sm-1">
            <img :src="(user_img_url) ? user_img_url : userDefaultImg" width="120px" height="120px" style="margin-left:30px;">
        </div>
        <div class="col-sm-7">
            <table class="cr-table client-info" style="margin-left:150px;">
                <tbody>
                    <tr>
                        <td width="100" style="font-weight: 900;">
                            {{$t("number")}}
                            <span class="line"></span>
                        </td>
                        <td width="200" style="font-weight: 900;">
                            {{$t("name")}}
                            <span class="line"></span>
                        </td>
                        <td width="120" style="font-weight: 900;">
                            {{$t("txt_29")}}
                            <span class="line"></span>
                        </td>
                        <td width="100" style="font-weight: 900;"> 
                            {{$t("heart_rate")}}
                            <span class="line"></span>
                        </td>
                        <td width="200" style="font-weight: 900;">
                            {{$t("consultant")}}
                            <span class="line"></span>
                        </td>
                        <td width="260" style="font-weight: 900;">
                            {{$t("measurement_time")}}
                            <span class="line"></span>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in reportData" :key="index">
                        <td>{{item.id}}</td>
                        <td>{{item.user_name}}</td>
                        <td>
                            <span :class="{'red_b': checkAberrantBpData('hbp', item.systolic_bp)}">{{ item.systolic_bp }}</span>
                            <span> / </span>
                            <span :class="{'red_b': checkAberrantBpData('lbp', item.diastolic_bp)}">{{item.diastolic_bp}}</span>
                        </td>
                        <td :class="{'red_b': checkAberrantBpData('hb', item.heartbeat)}">{{item.heartbeat}}</td>
                        <td>{{item.doc}}</td>
                        <td>{{item.datetime}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { checkAberrantBpData } from '@/js/checkBpData'
export default {
    props: ["reportInfo"],
    data() {
        return{
            reportData: [],
            user_img_url: '',
            userDefaultImg: 'https://hxesther-bucket.oss-cn-hangzhou.aliyuncs.com/hxesther/imgs/user2.png',
        }
    },
    created(){
        this.reportData.push(this.reportInfo);
        this.user_img_url = this.reportData[0].user_img_url;
    },
    methods: {
        
        checkAberrantBpData: checkAberrantBpData,
    }
}
</script>